export default {
      id: "icon-double-chevron-right-usage",
      viewBox: "0 0 13 14",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-double-chevron-right",
      toString: function () {
        return this.url;
      }
    }